export function formatDataLocaleString(date) {
    let d = new Date(date);
    let n = d.toLocaleString();
    return n;
}
export function formatNumberToBRL(number) {
    return number.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
}

//METHOD TO GROUP BY KEYGETTER.
//KEYGETTER MUST BE "foo => foo.fieldYouWantToGroupBy"
export function groupBy(list,keyGetter){
    const map = new Map();
    list.forEach((item) => {
        const key = keyGetter(item);
        const collection = map.get(key);
        
        if (!collection) { map.set(key, [item]); } 
        else { collection.push(item); }
    });
    return map;
}